import React from "react";

import DataTable from "components/basic/data-table/DataTable";
import { MaintenanceDto, MaintenanceHistoryDto } from "gql/generated/types";
import { T } from "services/lang/LanguageService";
import { DATE_FORMATTER_SECONDS } from "utils/constants";
import { parseToLocalZoneDateTime } from "utils/time-utils";
import { TableColumn } from "../../utils/types";
import { renderTag } from "../../utils/utils";

type MaintenanceHistoryTableProps = {
  maintenance: MaintenanceDto;
};

const MaintenanceHistoryTable: React.FC<MaintenanceHistoryTableProps> = ({ maintenance }) => {
  const columns: TableColumn<MaintenanceHistoryDto>[] = [
    {
      field: "timestamp",
      header: T("word.date"),
      columnKey: "timestamp",
      sortable: true,
      body: data => parseToLocalZoneDateTime(data.timestamp).format(DATE_FORMATTER_SECONDS),
    },
    {
      field: "fromStatus",
      header: T("word.from-status"),
      columnKey: "fromStatus",
      body: rowData => renderTag({status: rowData.fromStatus}),
      sortable: true,
    },
    {
      field: "toStatus",
      header: T("word.to-status"),
      columnKey: "toStatus",
      body: rowData => renderTag({status: rowData.toStatus}),
      sortable: true,
    },
    {
      field: "user",
      header: T("word.user"),
      columnKey: "user"
    },
    {
      field: "reason",
      header: T("word.reason"),
      columnKey: "reason"
    },
    {
      field: "interruptedServices",
      header: T("word.interrupted-services"),
      columnKey: "interruptedServices",
    }
  ];
  return (
    <DataTable
      columns={columns}
      data={(maintenance.history as MaintenanceHistoryDto[]) ?? []}
      tableConfig={{ style: { minHeight: "22rem" }, sortField: "timestamp", sortOrder: -1 }}
    />
  );
};

export default MaintenanceHistoryTable;